import { Component, OnInit } from '@angular/core';
import { KamonaOtpWidgetComponent } from '../../../kamona-otp-widget/kamona-otp-widget.component';
import { WebKamonaResentOtpModalComponent } from '../../../kamona-resent-otp-modal/partials/web-kamona-resent-otp-modal/web-kamona-resent-otp-modal.component';

@Component({
    selector: 'app-web-kamona-otp-widget',
    templateUrl: './web-kamona-otp-widget.component.html',
    styleUrls: ['./web-kamona-otp-widget.component.scss'],
})
export class WebKamonaOtpWidgetComponent extends KamonaOtpWidgetComponent implements OnInit {
    ngOnInit(): void {
        this.initialize();
    }

    getModalClassName() {
        return 'hide-ant-modal';
    }

    handleOtpAction() {
        const params = this.getResendOtpModalPayload();
        this.launchModal(params, WebKamonaResentOtpModalComponent);
        this.updateResendOptionCounter();
    }
}
